/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const XBadge16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            d="M8 1a7 7 0 110 14A7 7 0 018 1zm0 1a6 6 0 100 12A6 6 0 008 2zM5.784 5.089l.07.057L8 7.293l2.146-2.147.07-.057a.501.501 0 01.638.765L8.707 8l2.147 2.146a.501.501 0 01-.638.765l-.07-.057L8 8.707l-2.146 2.147-.07.057a.501.501 0 01-.638-.765L7.293 8 5.146 5.854a.501.501 0 01.638-.765z"
        />
    </AccessibleSVG>
);

export default XBadge16;
